import { BORDER_RADIUSES, colors, fontSizes } from '../../../Components/consts'
import { styled } from '@mui/system'


export const ChampSeriesScheduleCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  '& .dayGameCon': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
}))

export const ScheduleHead = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: theme.spacing(1),
}))

export const CSDayHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}))

export const CSGameRow = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '98%',
  border: `1px solid ${colors.gray.gray20}`,
  borderRadius: BORDER_RADIUSES.small,
  padding: theme.spacing(0, 2),
  marginTop: theme.spacing(1),
  '& .leagueCol': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 20,
    padding: theme.spacing(1, 2, 1, 0),
    '& img': {
     
      width: '100%',
    }
  },
  '& .gameTimeCol': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    '& p': {
      fontSize: fontSizes.small,
      marginRight: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.xSmall,
        marginRight: theme.spacing(0.5),
      },
    },
  },
  '& .teamCol': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 2
  },
  '& .actionCol': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 1
  },
}))
